var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "app-main-content",
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(170,170,170,0.5)"
      }
    },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: { "config-module": "901", "expand-adv": true, no: "1" },
                on: { advSearchItemCallBack: _vm.toAdvancedQuery }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { display: "flex" },
                    attrs: { slot: "operations" },
                    slot: "operations"
                  },
                  [
                    _c("span", { staticStyle: { color: "#666666" } }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ResponsibilityNew")))
                    ]),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "150px", "margin-left": "5px" },
                        attrs: { no: "2" },
                        on: { change: _vm.searchChangeHandler },
                        model: {
                          value: _vm.filter.dataType,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "dataType", $$v)
                          },
                          expression: "filter.dataType"
                        }
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PleaseSelectP"),
                            value: 0
                          }
                        }),
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_NotClearedToday"),
                            value: 1
                          }
                        }),
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ToBeClearedToday"),
                            value: 2
                          }
                        }),
                        _c("el-option", {
                          attrs: {
                            label: _vm.$t(
                              "CargoMsg.Cargo_DeclarationTheSameDay"
                            ),
                            value: 3
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { margin: "0 5px 0 12px" },
                        attrs: { no: "3" },
                        model: {
                          value: _vm.shutOut,
                          callback: function($$v) {
                            _vm.shutOut = $$v
                          },
                          expression: "shutOut"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ShutOut")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { margin: "0 12px 0 7px" },
                        attrs: { no: "4" },
                        model: {
                          value: _vm.filter.filterHistory,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "filterHistory", $$v)
                          },
                          expression: "filter.filterHistory"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_InculdeHistoricalData"))
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled:
                            !_vm.selectedNode ||
                            _vm.selectedNode.data.dataType === "0",
                          type: "primary",
                          no: "5"
                        },
                        on: { click: _vm.trackEventHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_DeclarationTracking"))
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled:
                            !_vm.selectedNode ||
                            _vm.selectedNode.data.dataType === "0",
                          type: "primary",
                          no: "6"
                        },
                        on: { click: _vm.trackFilghtEventHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FlightTracking")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "7" },
                        on: { click: _vm.batchUpdateStateEventHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("CargoMsg.Cargo_ModifyDeclarationBatches")
                          )
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "8" },
                        on: { click: _vm.printEventHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "9" },
                        on: { click: _vm.hasPrintEventHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PrintedTag")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "10" },
                        on: { click: _vm.printTagEvent }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PrintTag")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", no: "11" },
                        on: { click: _vm.checkDataEvent }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CheckData")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "150003",
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "deselect-sub-record": true,
                    "row-data": _vm.rowData
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "150003",
                    total: _vm.total,
                    page: _vm.pageNum,
                    limit: _vm.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      _vm.pageNum = $event
                    },
                    "update:limit": function($event) {
                      _vm.pageSize = $event
                    },
                    pagination: function($event) {
                      return _vm.toAdvancedQuery()
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("customs-maintain-dialog", {
        attrs: {
          visible: _vm.customsMaintainDialog.visible,
          job: _vm.customsMaintainDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.customsMaintainDialog, "visible", $event)
          },
          callback: _vm.callback
        }
      }),
      _c("flight-tracker-dialog", {
        attrs: {
          visible: _vm.flightTrackerDialog.visible,
          job: _vm.flightTrackerDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.flightTrackerDialog, "visible", $event)
          },
          callback: _vm.callback
        }
      }),
      _c("upd-declare-customs-state-dialog", {
        attrs: {
          visible: _vm.updDeclareCustomsStateDialog.visible,
          jobs: _vm.updDeclareCustomsStateDialog.jobs
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.updDeclareCustomsStateDialog, "visible", $event)
          },
          callback: _vm.callback
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }